import { theme } from 'theme'

const spacingHalf = theme.spacing(0.5)
const spacingOne = theme.spacing(1)
const spacingTwo = theme.spacing(2)

export { spacingHalf, spacingOne, spacingTwo }
